import type { TransportConfig } from '../types/transport';

export const DEFAULT_INTERNAL_TRANSPORT_BASE_URL =
  'https://micro-service-pixel-production-4826.up.railway.app';

export const DEFAULT_TRANSPORT_CONFIG: TransportConfig = {
  enabled: true,
  sender: {
    mode: 'internal',
    baseUrl: DEFAULT_INTERNAL_TRANSPORT_BASE_URL,
  },
  persistence: { enabled: true },
  replay: { enabled: true },
  ordering: { enabled: true },
  coordination: { enabled: true },
  circuitBreaker: {
    enabled: true,
    failureThreshold: 5,
    resetTimeoutMs: 30_000,
    halfOpenMaxAttempts: 2,
  },
  backpressure: {
    enabled: true,
    maxQueueSize: 500,
    policy: 'drop_oldest',
    sampleRate: 0.5,
  },
  deadLetter: {
    enabled: true,
    maxEntries: 200,
  },
  compression: {
    enabled: true,
    strategy: 'identity',
  },
  retry: {
    enabled: true,
    maxAttempts: 4,
    baseDelayMs: 500,
    maxDelayMs: 4_000,
    multiplier: 2,
  },
  batch: {
    enabled: true,
    batchSize: 10,
    maxWaitMs: 5_000,
  },
  timeout: {
    enabled: true,
    timeoutMs: 10_000,
  },
  offline: { enabled: true },
  flush: {
    enabled: true,
    flushIntervalMs: 2_000,
    flushOnDestroy: true,
    prepareUnloadHooks: true,
  },
};
